import React from 'react';
import '../../assets/stylesheets/Units/Notification.scss';

const Notification = ({count}) => {
    return (
        <React.Fragment>
            { count > 0 &&
                <span className={`newNotificationsCount`}>
                    {count}
                </span>
            }
        </React.Fragment>
    )
}
export default Notification;
